import { styled } from '@linaria/react';

export const StartTimeText = styled.a`
  font-family: var(--ogm-font-family-2);
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  grid-area: start-time;
  color: var(--ogm-text-body);
  text-decoration: uppercase;

  @media (min-width: 768px) {
    line-height: 19px;
  }
`;
